import { FlexGap, FormWrapperMinimum, StackHorizontal } from '@ukpostbox/frontend-framework';
import { useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';

type ReceivedConditionType = {
	name: string;
	defaultValue: any;
	changeCallback: (value: any) => void;
};

function ReceivedCondition(props: ReceivedConditionType) {
	const { formState, register } = useFormContext();

	return (
		<StackHorizontal gap={FlexGap.ExtraSmall}>
			<div className='input-addon'>
				<FormWrapperMinimum
					invalid={
						formState.errors[props.name] &&
						formState.errors[props.name] &&
						formState.errors[props.name]?.message !== ''
					}
					validationMessage={
						formState.errors[props.name] ? (formState.errors[props.name]?.message as string) : ''
					}
				>
					<input
						type='number'
						step={1}
						min={1}
						aria-invalid={formState.errors[props.name] ? 'true' : 'false'}
						defaultValue={props.defaultValue}
						{...register(props.name, { required: 'This is a required field' })}
					/>
					<div className='input-addon-icon'>Days Ago</div>
				</FormWrapperMinimum>
			</div>
		</StackHorizontal>
	);
}

export { ReceivedCondition };
